import React from 'react';
import { Box, Card, Divider } from '@mui/material';
import { ObjectiveMeta } from 'shared/domain/objectivePresets';
import { CustomTypography } from 'shared/ui/CustomTypography';

interface ObjectiveStatusCardProps {
  objective: ObjectiveMeta;
  cfdId?: string;
  value?: number;
  statusLabel: string;
}

const cardSx = {
  background: 'linear-gradient(135deg, rgba(255,255,255,0.16), rgba(255,255,255,0.06))',
  border: '1px solid rgba(255,255,255,0.24)',
  borderRadius: 2,
  boxShadow: '0 10px 24px rgba(6, 24, 44, 0.24)',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)',
  paddingX: 1.2,
  paddingY: 1,
};

const rowSx = {
  display: 'grid',
  gridTemplateColumns: '68px 1fr',
  gap: 0.75,
  alignItems: 'start',
  paddingY: 0.2,
};

const formatCfdId = (cfdId?: string) => {
  if (!cfdId) return 'N/A';
  if (/^\d+$/.test(cfdId)) {
    return cfdId.replace(/(\d{4})(?=\d)/g, '$1 ');
  }
  return cfdId;
};

export const ObjectiveStatusCard: React.FC<ObjectiveStatusCardProps> = ({
  objective,
  cfdId,
  value,
  statusLabel,
}) => {
  const formattedCfdId = formatCfdId(cfdId);
  const valueText = typeof value === 'number' && Number.isFinite(value)
    ? value.toFixed(3)
    : 'N/A';

  return (
    <Card sx={cardSx}>
      <Box component="div" sx={{ paddingBottom: 0.25 }}>
        <CustomTypography sx={{ color: objective.color }}>
          Objective: {objective.label}
        </CustomTypography>
      </Box>
      <Divider sx={{ my: 0.4, bgcolor: 'rgba(255,255,255,0.22)' }} />

      <Box component="div" sx={rowSx}>
        <CustomTypography sx={{ color: '#b5c7ef' }}>CFD ID</CustomTypography>
        <CustomTypography sx={{ color: '#f5f8ff', whiteSpace: 'normal', overflowWrap: 'anywhere', lineHeight: 1.4 }}>
          {formattedCfdId}
        </CustomTypography>
      </Box>

      <Box component="div" sx={rowSx}>
        <CustomTypography sx={{ color: '#b5c7ef' }}>Value</CustomTypography>
        <CustomTypography sx={{ color: '#b5f5cc' }}>
          {valueText}
        </CustomTypography>
      </Box>

      <Box component="div" sx={rowSx}>
        <CustomTypography sx={{ color: '#b5c7ef' }}>Status</CustomTypography>
        <CustomTypography sx={{ color: '#ffc9c9', whiteSpace: 'normal' }}>
          {statusLabel}
        </CustomTypography>
      </Box>
    </Card>
  );
};
